import { cn } from "@/lib/utils";

// Rótulo de lo que la landing muestra y el producto todavía no tiene (`proximamente: true` en
// content.js). Uno solo para todas las secciones: al lanzar la función se borra el flag y el rótulo
// desaparece en todas a la vez.
export const Proximamente = ({ className }) => (
  <span
    className={cn(
      "inline-flex items-center whitespace-nowrap rounded-full bg-slate-100 px-2 py-0.5 text-[11px] font-semibold text-slate-500 ring-1 ring-inset ring-slate-200",
      className,
    )}
  >
    Próximamente
  </span>
);
